module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Hacks-.14830513.jpg";